import React from "react";

const IconLogo = () => {
  return (
    <svg
      width="63"
      height="33"
      viewBox="0 0 52 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.8416 23.2729V8.742H7.88477V23.2729H10.8416Z" fill="white" />
      <path
        d="M21.6608 19.4111V17.9929H19.0141V19.3456C19.0141 20.3493 18.4558 21.0038 17.3599 21.0038C16.264 21.0038 15.7057 20.3275 15.7057 19.4111V12.6256C15.7057 11.6875 16.264 11.0111 17.3599 11.0111C18.4558 11.0111 19.0141 11.6656 19.0141 12.6693V14.022H21.6608V12.6038C21.6608 10.182 20.1927 8.37109 17.3185 8.37109C14.403 8.37109 12.7075 10.3565 12.7075 12.8656V19.1493C12.7075 21.6584 14.403 23.6438 17.3185 23.6438C20.1927 23.6438 21.6608 21.8329 21.6608 19.4111Z"
        fill="white"
      />
      <path
        d="M32.1837 19.1929V12.822C32.1837 10.2475 30.5088 8.39291 27.6553 8.39291C24.8225 8.39291 23.1269 10.2475 23.1269 12.822V19.1929C23.1269 21.7893 24.8225 23.6438 27.6553 23.6438C30.5088 23.6438 32.1837 21.7893 32.1837 19.1929ZM29.2061 19.3675C29.2061 20.3493 28.6478 21.0038 27.6553 21.0038C26.6835 21.0038 26.1252 20.3493 26.1252 19.3675V12.6475C26.1252 11.6656 26.6835 11.0111 27.6553 11.0111C28.6478 11.0111 29.2061 11.6656 29.2061 12.6475V19.3675Z"
        fill="white"
      />
      <path
        d="M43.2157 23.2729V8.742H40.5483V17.0766L39.4317 14.6984L36.4749 8.742H34.0143V23.2729H36.723V15.0693L37.9016 17.4475L40.9412 23.2729H43.2157Z"
        fill="white"
      />
      <rect
        x="1.36538"
        y="1.36538"
        width="48.2735"
        height="29.2692"
        rx="2.73076"
        stroke="white"
        strokeWidth="2.73076"
      />
    </svg>
  );
};

export default IconLogo;
